import classnames from 'classnames';

import caretStyles from '../../../../styles/dropdownCaret.module.css';

import styles from './DropdownToggle.module.css';

/**
 * The UK footer's caret. The other style drew a `+`/`−` here — two crossed bars rotated 46deg, one of
 * them dropped when open — and now renders cxy's chevron through `Accordion.Item` instead (NGF-7074).
 */
export const DropdownToggle = ({ isOpen }: { isOpen: boolean }) => (
  <span aria-hidden="true" className={styles.caretSlotUk} data-testid="footer-nav-group-caret">
    <span className={classnames(caretStyles.caret, isOpen && caretStyles.caretOpen)} />
  </span>
);
